import sanityClient from '@sanity/client';

export default sanityClient({
    projectId: "olfmsbp0",
    dataset: "production"
})